import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router';
import { toast } from 'react-hot-toast';

import { Button } from '@project/components';

import { userAuthService } from '../../../services';
import { VerifyNewEmailProps } from '../../../types';

export const VerifyNewEmailScreen: React.FC = () => {
  const { search } = useLocation();
  const [verifyAccountError, setVerifyAccountError] = useState<string | null>(null);
  const history = useHistory();

  const attemptVerification = async (retry = false) => {
    const token = new URLSearchParams(search).get('token') || '';
    const email = new URLSearchParams(search).get('email') || '';
    const newEmail = new URLSearchParams(search).get('newemail') || '';
    const requestData: VerifyNewEmailProps = { email, token, newEmail };

    try {
      await userAuthService.verifyNewEmail(requestData);
      toast.success('Successfully verified new email');
      history.replace('/login');
    } catch {
      if (!retry) {
        attemptVerification(true);
      } else {
        setVerifyAccountError(
          'An error occurred during email verification. Please try again or log in manually.',
        );
      }
    }
  };

  useEffect(() => {
    attemptVerification();
  }, []);

  return (
    <div className="flex flex-1 flex-col items-center justify-center p-4">
      {verifyAccountError && (
        <>
          <p className="text-red-600 mb-4">{verifyAccountError}</p>
          <Button
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
            onClick={() => history.push('/login')}
          >
            Go to Login
          </Button>
        </>
      )}
    </div>
  );
};
